import axios from 'axios';

const ajax = axios.create({
    baseURL: '/ajax',
});

ajax.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

export default ajax;
